module.exports = __webpack_public_path__ + "img/ivan_danyliuk.e07160aa.png";